import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class OnixsatService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'onixsat');
  }

  buscarPorData(dataHoraInicial: string, estacaoId: number, dataHoraFinal?: string): Observable<any> {
    const body: any = {
      data_hora_inicial: dataHoraInicial,
      estacao_id: estacaoId
    };
    if (dataHoraFinal) {
      body.data_hora_final = dataHoraFinal;
    }
    return this.http.post(`${this.url_base}/${this.prefixo}/buscar-por-data`, body);
  }

}

